var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.length>1)?_c('a-select',{style:(_vm.style),attrs:{"value":_vm.currentCurrency},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('a-select-option',{key:item.item_id,attrs:{"value":item.item_id}},[_vm._v(_vm._s(item.item_name))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }